import api from '../../api/api'

/* ------------- Types ------------- */
export interface OrderItemObject {
  esimDevice: string
}

export interface Order {
  msisdn?: string
  status: string
  orderPrice: number
  orderItem: Array<OrderItemObject>
}

export interface Product {
  id: string
  status: 'Active'
  specificationId: string
  characteristic: {
    eId: string
    sim?: string
    eSimDevice: string
  }
}

export interface EsimObject {
  iccid: string
  state: 'Active' | 'InProgress'
  subState: 'Released' | 'Reserved' | 'Downloaded' | 'Available'
  eId?: string
}

export interface UsersData {
  attributes?: {
    familyRole?: string[] // familyRole is present only for members
  }
}

export interface ProductsData extends Array<Product> {}

export interface OrdersData {
  orders: Array<Order>
  postOrderData: PostOrdersMultisimData
  isPostOrderRequest: boolean
  patchOrderData: PatchOrdersMultisimData
  isPatchOrderRequest: boolean
}

export interface EsimData extends Array<EsimObject> {}

export interface SwapEsim {
  action: 'Delete'
  id: string
}

export interface PostOrdersMultisimData {
  id: string
  status: 'Draft' | 'Submitted'
  dopUserId: string
  orderPrice: number
  orderItem: [
    {
      action: 'Add'
      recurringCharge: number
      recurringTotal: number
      deliveryType: 'ESIM'
      parentId: string
      oneTimeTotal: number
      esimDevice: 'A_WATCH'
      offer: {
        vlocityCatalogItemId: 'P-MultiSIMCard'
      }
    }
  ]
}
export interface PostExchangeOrdersMultisimData {
  id: string
  status: 'Draft' | 'Submitted'
  dopUserId: string
  orderPrice: number
  orderItem: [
    SwapEsim,
    {
      action: 'Add'
      recurringCharge: number
      recurringTotal: number
      deliveryType: 'ESIM'
      parentId: string
      oneTimeTotal: number
      esimDevice: 'A_WATCH'
      offer: {
        vlocityCatalogItemId: 'P-MultiSIMCard'
      }
    }
  ]
}

export interface PatchOrdersMultisimData {
  id: string
  customerOrderId: string
  status: 'Submitted'
  dopUserId: string
  orderPrice: string
  orderItem: [
    {
      action: 'Add'
      recurringCharge: string
      recurringTotal: string
      deliveryType: 'ESIM'
      iccid: string
      parentId: string
      oneTimeTotal: string
      eid: string
      esimDevice: 'A_WATCH'
      offer: {
        vlocityCatalogItemId: 'P-MultiSIMCard'
      }
    }
  ]
}

/* ------------- Api ------------- */
export const getUsersApi = () => api.get<UsersData>('/users')

export const getProductsApi = () => api.get<ProductsData>('/products')

export const getOrdersApi = () => api.get<OrdersData>('/orders')

export const getEsimApi = () => api.get<EsimData>('/esims')

export const postOrdersMultisimApi = (productId: string, id?: string) => {
  const orderItem = {
    action: 'Add',
    parentId: `${productId}`,
    offer: {
      vlocityCatalogItemId: 'P-MultiSIMCard',
    },
    deliveryType: 'ESIM',
    eSimDevice: 'A_WATCH',
  }
  const orderExchangeItem = {
    action: 'Delete',
    id,
  }
  return api.post<PostOrdersMultisimData | PostExchangeOrdersMultisimData>('/orders/multisim', {
    orderItem: id ? [orderItem, orderExchangeItem] : [orderItem],
  })
}

// id in POST response
export const patchOrdersMultisimApi = (eid: string, multisimOrderId: string) =>
  api.patch<PatchOrdersMultisimData>(`/orders/multisim/${multisimOrderId}`, {
    orderItem: [
      {
        action: 'Add',
        deliveryType: 'ESIM',
        eid: `${eid}`,
        eSimDevice: 'A_WATCH',
      },
    ],
  })
